import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "d-flex justify-content-center align-items-center",
  style: {"height":"70vh !important"}
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", {
  class: "spinner-border",
  role: "status"
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "visually-hidden" }, "Laddar...")
], -1)
const _hoisted_3 = [
  _hoisted_2
]


    
export default /*#__PURE__*/_defineComponent({
  __name: 'Spinner',
  props: {
    spinn: { type: Boolean }
  },
  setup(__props: any) {

const props = __props as { spinn: boolean }

    

return (_ctx: any,_cache: any) => {
  return (__props.spinn)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_3))
    : _createCommentVNode("", true)
}
}

})